import { renderBeat } from "@kosmod/graphics-3d";
import { Component, h, useRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { TheatreDragSubject } from "../../../hooks/useTheatreSelection";
import { TheatreState } from "../../../hooks/useTheatreState";
import { Particle, Simulation, useAsync, useLogger } from "@kosmod/kit";

import * as three from 'three';
import { MiniTemplateIcon } from "./MiniList";
import { ToolSlotRenderer } from "../../Tools/ToolSlotRenderer";

export type DragPreviewProps = {
  target: TheatreDragSubject,

  state: TheatreState,
}

export const DragPreview: Component<DragPreviewProps> = ({ target, state }) => {
  const ref = useRef<HTMLElement | null>(null);
  const logger = useLogger('DragPreview');

  const simData = useRef(() => {
    const sim = new Simulation();
    const cursorParticle = new Particle();

    cursorParticle.dragCoefficient = .65;
    sim.particles.push(cursorParticle);

    const cursorPosition = state.cursor2DPosition.get();

    if (cursorPosition)
      cursorParticle.position.copy(cursorPosition);

    return { sim, cursorParticle };
  }).get();

  renderBeat.useBeat(() => {
    const previewElement = ref.get();
    if (!previewElement || !simData)
      return logger.log(`No Preview Element`);
    
    const cursorPosition = state.cursor2DPosition.get();

    if (!cursorPosition) {
      previewElement.style.visibility = 'hidden'
      //return logger.log(`No 2D Position`);
      return;
    }
    previewElement.style.visibility = 'visible'

    const distanceVector = cursorPosition.clone()
      .sub(simData.cursorParticle.position)

    const SPRING_LENGTH = 100;
    const SPRING_POWER = 0.24;

    const distance = Math.min(SPRING_LENGTH, distanceVector.length());
    const direction = distance === 0 ? new three.Vector2(0, 0) : distanceVector.clone().divideScalar(distance);

    const forcePower = (distance) * SPRING_POWER;
    const force = direction.clone().multiplyScalar(forcePower);

    simData.cursorParticle.acceleration.copy(force);
    simData.cursorParticle.velocity.multiplyScalar(simData.cursorParticle.dragCoefficient)

    simData.sim.tick();

    // manual decay

    previewElement.style.transform = `
      translate(${simData.cursorParticle.position.x}px, ${simData.cursorParticle.position.y}px)
      translate(-50%, -50%)
    `;
  })

  const buildPreviewElement = () => {
    switch (target.type) {
      case 'mini-template':
        const miniTemplate = state.data.miniTemplates.get(target.miniTemplateID)!;
        return h(MiniTemplateIcon, { resources: state.sceneRes, miniTemplate, graphicsSetup: state.graphics, content: state.content });
      case 'tool':
        return h(ToolSlotRenderer, { state, tool: target.toolState });
    }
  }

  return h(html.div, {
    ref,
    style: { position: 'absolute', left: '0', top: '0', pointerEvents: 'none', height: '64px', width: '64px' }
  }, buildPreviewElement());
};

